import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orders.title',
    defaultMessage: 'Orders',
    description: 'title of the orders page',
  },
  create: {
    button: {
      id: 'pages.orders.create.button',
      defaultMessage: 'Create',
      description: 'Label of the create button on the orders page',
    },
  },
  actions: {
    createOrder: {
      id: 'pages.orders.actions.createOrder',
      defaultMessage: 'New order',
      description: 'Label of the create order action on the orders page',
    },
    createPurchaseOrder: {
      id: 'pages.orders.actions.createPurchaseOrder',
      defaultMessage: 'New purchase order',
      description: 'Label of the create purchase order action on the orders page',
    },
  },
  previewActions: {
    view: {
      label: {
        id: 'actions.view',
        defaultMessage: 'View',
        description: 'Label of the view action in the order preview',
      },
    },
    edit: {
      label: {
        id: 'actions.edit',
        defaultMessage: 'Edit',
        description: 'Label of the edit action in the order preview',
      },
    },
    delete: {
      label: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'Label of the delete action in the order preview',
      },
    },
  },
  confirmDeleteOrder: {
    title: {
      id: 'confirmDeleteOrder.title',
      defaultMessage: 'Delete order',
      description: 'Delete order confirm dialog title',
    },
    description: {
      id: 'confirmDeleteOrder.description',
      defaultMessage: 'Are you sure you would like to delete this order?',
      description: 'Delete order confirm dialog description',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Delete order confirm dialog cancel button label',
      },
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'Delete order confirm dialog delete button label',
      },
    },
  },
  feedback: {
    orderDeleted: {
      id: 'pages.orderView.feedback.orderDeleted',
      defaultMessage: 'Order deleted',
      description: 'Order delete success message',
    },
    orderNotDeleted: {
      id: 'pages.orderView.feedback.orderNotDeleted',
      defaultMessage: 'Order could not be deleted!',
      description: 'Order delete error message',
    },
  },
};

export default defineMessages(translations);
